export const ADMIN_ROLES = Object.freeze({
  SUPER_ADMIN: "super_admin",
  REVIEW_ADMIN: "review_admin",
});

const ADMIN_ROLE_RANK = Object.freeze({
  [ADMIN_ROLES.REVIEW_ADMIN]: 1,
  [ADMIN_ROLES.SUPER_ADMIN]: 2,
});

export function resolveAdminRole(user) {
  if (!user?.isOuroAdmin) {
    return null;
  }

  if (
    user.adminRole === ADMIN_ROLES.SUPER_ADMIN ||
    user.adminRole === ADMIN_ROLES.REVIEW_ADMIN
  ) {
    return user.adminRole;
  }

  return ADMIN_ROLES.SUPER_ADMIN;
}

export function hasAdminRole(user, allowedRoles = []) {
  const resolvedRole = resolveAdminRole(user);
  if (!resolvedRole) {
    return false;
  }

  if (!Array.isArray(allowedRoles) || allowedRoles.length === 0) {
    return true;
  }

  const adminRank = ADMIN_ROLE_RANK[resolvedRole] || 0;
  return allowedRoles.some((role) => adminRank >= (ADMIN_ROLE_RANK[role] || 0));
}

export function isSuperAdmin(user) {
  return hasAdminRole(user, [ADMIN_ROLES.SUPER_ADMIN]);
}

export function canManageAdvancedUserTools(user) {
  return isSuperAdmin(user);
}

export function canManageAdminAccess(user) {
  return isSuperAdmin(user);
}

export function canViewDashboard(user) {
  return isSuperAdmin(user);
}

export function canViewFinance(user) {
  return isSuperAdmin(user);
}

export function canViewAnticheat(user) {
  return isSuperAdmin(user);
}

export function canViewGuard(user) {
  return isSuperAdmin(user);
}

export function canExecuteDataDeletion(user) {
  return isSuperAdmin(user);
}

export function getDefaultAdminRoute(user) {
  return canViewDashboard(user) ? "/dashboard" : "/users";
}
